import { __awaiter } from '../node_modules/tslib/tslib.es6.js';
import '../api/graphQl/brand.js';
import '../api/graphQl/product.js';
import { sendText } from '../api/utils.js';
import '../api/cache/appConfigQueryOptions.js';
import { buildTrackingParams } from './analytics.js';

const sendTextCallback = (phoneNumber, axios, mainEntity, analyticsTrack, trackingParams, trackingEventName) => __awaiter(void 0, void 0, void 0, function* () {
    const queryParams = buildTrackingParams({ trackingParams, mainEntity });
    const sourceMetaData = {};
    if ((mainEntity === null || mainEntity === void 0 ? void 0 : mainEntity.type) === 'product') {
        sourceMetaData.sku = mainEntity === null || mainEntity === void 0 ? void 0 : mainEntity.entity.stacklineSku;
        sourceMetaData.brandId = mainEntity === null || mainEntity === void 0 ? void 0 : mainEntity.entity.brandId;
    }
    else if ((mainEntity === null || mainEntity === void 0 ? void 0 : mainEntity.type) === 'brand') {
        sourceMetaData.brandId = parseInt(`${mainEntity === null || mainEntity === void 0 ? void 0 : mainEntity.id}`);
    }
    const result = yield sendText(axios, {
        phoneNumber,
        queryParams,
        source: (mainEntity === null || mainEntity === void 0 ? void 0 : mainEntity.type) === 'product'
            ? 'productLandingPage'
            : (mainEntity === null || mainEntity === void 0 ? void 0 : mainEntity.type) === 'brand'
                ? 'brandLandingPage'
                : 'outerPage',
        sourceMetaData,
    });
    if (analyticsTrack) {
        analyticsTrack(trackingEventName, Object.assign(Object.assign({}, queryParams), { phoneNumber }));
    }
    return result;
});

export { sendTextCallback };
//# sourceMappingURL=textMessage.js.map
